import React from "react";
import { Card, CardMedia } from "@mui/material";
import SearchBanner from "../../assets/images/search-banner.png";

const LocationMap = () => {
    return (
        <Card className="location-map-wrapper">
            <CardMedia
                component="img"
                image={SearchBanner}
                className="search-banner-image"
            />
        </Card>
    );
};

export default LocationMap;
